import { render, staticRenderFns } from "./BasicConfig.vue?vue&type=template&id=051ec109&scoped=true&"
import script from "./BasicConfig.vue?vue&type=script&lang=js&"
export * from "./BasicConfig.vue?vue&type=script&lang=js&"
import style0 from "./BasicConfig.vue?vue&type=style&index=0&id=051ec109&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ec109",
  null
  
)

export default component.exports